export default "__VITE_ASSET__CrhPmbCy__"